// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TUpdateMailingTogglesRequest,
  TUpdateMailingTogglesModel,
  IMappers,
  TUpdateMailingTogglesResponse,
  TUpdateMailingTogglesResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createUpdateMailingTogglesModel(parameters: TUpdateMailingTogglesRequest): TUpdateMailingTogglesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'discount-about-realty-offer',
    pathApi: '/v1/update-mailing-toggles/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IUpdateMailingTogglesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TUpdateMailingTogglesRequest;
}

export async function fetchUpdateMailingToggles<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUpdateMailingTogglesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TUpdateMailingTogglesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createUpdateMailingTogglesModel(parameters),
    config,
  )) as FetchResponse<TUpdateMailingTogglesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TUpdateMailingTogglesResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TUpdateMailingTogglesResponse>;
}
